// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Q3GI","content":"styles_content__39msz"};